import Setting from '@/setting';
import { createRouter, createWebHistory, createWebHashHistory, createMemoryHistory } from 'vue-router';
import routes from './routes'; // router.beforeEach((to, from, next) => {
//     // if (to.path == '/contentCtr') {
//     //     console.log('back...', from, to)
//     //     from.meta.keepAlive = false
//     //     to.meta.keepAlive = true
//     // }
//     /* 路由发生变化修改页面title */
//     if (to.meta.title) {
//         document.title = to.meta.title
//     }
//     next()
// })
// router.afterEach((to, from, next) => {
//     window.scrollTo(0, 0);
// })

const router = createRouter({
  history: Setting.routerMode === 'history' ? createWebHistory(Setting.routerBase) : Setting.routerMode === 'hash' ? createWebHashHistory(Setting.routerBase) : createMemoryHistory(Setting.routerBase),
  routes
});
export default router;